import {Tr} from '../../_metronic/i18n/Tr'
import PriceInput from './PriceInput'

export type SpecialPriceDay = {
  key: string // validation error key, e.g. 'hourlyMondayPrice'
  label: string // untranslated day name, e.g. 'Monday'
  value: string
  setValue: (value: string) => void
}

type Props = {
  title: string
  days: SpecialPriceDay[]
  required?: boolean
  errors: any
  clearError: (key: string) => void
}

// Weekly special price editor: day names on the left, prices on the right,
// with a button that copies the first day's price to every day.
const SpecialPriceDays = ({title, days, required = true, errors, clearError}: Props) => {
  const t = Tr()

  const applyToAllDays = () => {
    const value = days[0]?.value ?? ''
    days.forEach((day) => {
      day.setValue(value)
      clearError(day.key)
    })
  }

  return (
    <div className='row'>
      <div className='col-12 mb-3 d-flex flex-wrap justify-content-between align-items-center gap-2'>
        <h4 className='mb-0'>{t(title)}</h4>
        <button
          type='button'
          className='btn btn-sm btn-light-primary'
          onClick={applyToAllDays}
        >
          <i className='fas fa-copy me-1'></i>
          {t('Apply to all days')}
        </button>
      </div>
      {days.map((day) => (
        <div className='col-12 mb-3' key={day.key}>
          <div className='row align-items-center'>
            <div className='col-4'>
              <label className={`fs-6 form-label mb-0 ${required ? 'required' : ''}`}>
                {t(day.label)}
              </label>
            </div>
            <div className='col-8'>
              <PriceInput
                inputClass='form-control mb-0 border-right-0'
                placeholder={t('Price')}
                value={day.value}
                onChange={(e: any) => {
                  day.setValue(e)
                  clearError(day.key)
                }}
              />
            </div>
          </div>
          {errors[day.key] && (
            <div className='row'>
              <div className='col-8 offset-4 text-danger fw-bold'>{errors[day.key]}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default SpecialPriceDays
